/**
 * @param  {Object} state
 * @return {Object}
 */
export const OPTIONS = state => {
  return state
}



// WEBPACK FOOTER //
// ./src/store/modules/options/getters.js